module.exports = __webpack_public_path__ + "static/media/ss11_preview.8f8b6786.jpg";